import Login from "./pages/Login";
import Sidebar from "./components/Sidebar";
import CompanyHeader from "./components/CompanyHeader";
import "./App.css";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import AuthGuard from "./routes/AuthGuard";
import ModuleGuard from "./routes/ModuleGuard";
import Home from "./pages/Home";
import Report from "./pages/Report";
import ReportDetails from "./pages/ReportDetails";
import PublicReportDetails from "./pages/PublicReportDetails";
import ContainerLookup from "./pages/ContainerLookup";
import ShippingLine from "./pages/ShippingLine";
import Company from "./pages/Company";
import CompanyYard from "./pages/Company/Yard";
import CompanyConfig from "./pages/Company/Config";
import CompanyYardUser from "./pages/Company/Yard/User";
import CompanyYardMachine from "./pages/Company/Yard/Machine";
import VehicleTag from "./pages/Company/Yard/VehicleTag";

function App() {
  return (
    <Provider store={store}>
      <ToastContainer />
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/container-lookup/:companyId/:yardId?" element={<ContainerLookup />} />
          <Route path="/public-report-details/:scanStageId" element={<PublicReportDetails />} />
          <Route element={<AuthGuard redirectPath="/" />}>
            <Route
              element={
                <div className="flex flex-row h-screen">
                  <Sidebar />
                  <div className="flex flex-col w-full overflow-hidden">
                    <CompanyHeader />
                    <div className="flex-1 overflow-auto">
                      <Outlet />
                    </div>
                  </div>
                </div>
              }
            >
              {/* Always accessible — Home renders both Yard and Warehouse content internally */}
              <Route path="/home" element={<Home />} />
              <Route path="/report" element={<Report />} />
              <Route path="/company" element={<Company />} />
              <Route path="/company/:company_id/yards" element={<CompanyYard />} />
              <Route path="/company/:company_id/configuration" element={<CompanyConfig />} />
              <Route path="/company/:company_id/yards/:yard_id/users" element={<CompanyYardUser />} />
              <Route path="/company/:company_id/yards/:yard_id/machines" element={<CompanyYardMachine />} />
              <Route path="/company/:company_id/yards/:yard_id/vehicles" element={<VehicleTag />} />

              {/* NEW — Yard-only routes, redirected to /home if activeModule isn't YARD */}
              <Route element={<ModuleGuard requiredModule="YARD" />}>
                <Route path="/report-details/:id/:key" element={<ReportDetails />} />
                <Route path="/shipping_line" element={<ShippingLine />} />
              </Route>

            </Route>
          </Route>
          <Route path="*" element={<h1>404 Not Found</h1>} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;